<div style="user-select: none; width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center;">
    <div style="margin: 10px; width: 100%; height: 100%; display: flex; flex-direction: row; justify-content: center;" >
        <iframe className="pdfPreviewInner" [frameBorder]="0" allowtransparency="false" title="Preview" [src]="docData" height="100%" width="98%"></iframe>
    </div>
    
    <div mat-dialog-actions style="justify-content: right;">
        <button mat-flat-button color="primary" mat-dialog-close>Close</button>
    </div>
</div>